import { useEffect } from "react";
import { APP_ROUTES } from "../constants";
import { useSessionStore } from "../store/useSessionStore";
import { RequestStatus } from "../utils/commons";
import {
  consumedOperationId,
  resolveConsumedResumePath,
} from "../utils/consumed-resume";
import { isLinkUsageConsumed } from "../utils/link-usage";
import { useClaimLink } from "./useClaimLink";
import { useRouteWithToken } from "./useRouteWithToken";

/**
 * Bookmark / back-navigation guard: a consumed Lola link cannot return to
 * payment screens. Cash resumes how-to; card stays on already-used.
 */
export function useConsumedLinkGuard() {
  useClaimLink();
  const { session } = useSessionStore();
  const { redirectTo, linkId } = useRouteWithToken();

  const config = session.data?.config;
  const sessionLinkId = session.data?.linkId ?? linkId;

  useEffect(() => {
    if (
      session.status !== RequestStatus.LOADED ||
      !isLinkUsageConsumed(config)
    ) {
      return;
    }

    if (!sessionLinkId) {
      redirectTo(APP_ROUTES.LINK_ALREADY_USED_PAGE, { replace: true });
      return;
    }

    let cancelled = false;
    void resolveConsumedResumePath({
      linkId: sessionLinkId,
      operationId: consumedOperationId(config),
    }).then((path) => {
      if (!cancelled) {
        redirectTo(path, { replace: true });
      }
    });

    return () => {
      cancelled = true;
    };
  }, [session.status, config, sessionLinkId, redirectTo]);
}
